export function calculateFileSize(fileSize?: number) {
  const size = (fileSize ?? 0) / 1024;
  return `${size.toFixed(2)} kb`;
}

export function openFile(path: string, params?: [{ key: string; value: string }]) {
  let paramString = "";

  if (params) {
    paramString += "?";
    for (const { key, value } of params) {
      paramString += `${key}=${value}`;
    }
  }

  window.open(`${path}.pdf${paramString}`, "_blank");
}
